import { TooltipContent, TooltipProvider, TooltipRoot, TooltipTrigger, isMac } from "./utils-BxEJOnFD.js";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/Tooltip/toggleAll.ts
/** True for the click that should fold or unfold every group: Cmd on a Mac, Ctrl elsewhere. */
const isToggleAllClick = (event) => isMac ? event.metaKey : event.ctrlKey;
// src/components/Tooltip/ToggleAllTooltip.tsx
/**
* A fold chevron's tooltip: what a click does, and what the modifier click does to every group.
*
* - Its own provider, so a host without one still renders it.
*/
const ToggleAllTooltip = ({ expanded, children }) => {
	const verb = expanded ? "collapse" : "expand";
	return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsxs(TooltipRoot, { children: [/* @__PURE__ */ jsx(TooltipTrigger, {
		asChild: true,
		children
	}), /* @__PURE__ */ jsx(TooltipContent, {
		placement: "top",
		children: /* @__PURE__ */ jsxs("span", {
			className: "tw:flex tw:flex-col",
			children: [/* @__PURE__ */ jsxs("span", { children: ["Click to ", verb] }), /* @__PURE__ */ jsxs("span", {
				className: "tw:opacity-70",
				children: [
					isMac ? "⌘" : "Ctrl",
					"+click to ",
					verb,
					" all"
				]
			})]
		})
	})] }) });
};
export { ToggleAllTooltip, isToggleAllClick };

//# sourceMappingURL=ToggleAllTooltip-DQE5Lw6w.js.map